import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6080127b")

_pushScopeId("data-v-6080127b")
const _hoisted_1 = { class: "form-content" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_cus_option = _resolveComponent("cus-option")
  const _component_cus_select = _resolveComponent("cus-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_radio = _resolveComponent("el-radio")
  const _component_el_form = _resolveComponent("el-form")
  const _component_cus_button = _resolveComponent("cus-button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      ref: "formRef",
      model: _ctx.formData,
      "label-width": "80px",
      class: "width500px",
      "label-position": _ctx.$formLabelPosition
    }, {
      default: _withId(() => [
        _createVNode(_component_el_form_item, {
          label: _ctx.$wordList.DarshbordTimeZone
        }, {
          default: _withId(() => [
            _createVNode(_component_cus_select, {
              modelValue: _ctx.formData.TimeZone,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.TimeZone = $event)),
              filter: "",
              "no-data-text": _ctx.$wordList.ListNoData,
              "no-match-text": _ctx.$wordList.ListNoData
            }, {
              default: _withId(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.timeZone.timeZoneOptions, (item) => {
                  return (_openBlock(), _createBlock(_component_cus_option, {
                    key: item.value,
                    label: item.label,
                    value: item.value
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "no-data-text", "no-match-text"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          label: _ctx.$wordList.NavInHtmlTimeFormat 
        }, {
          default: _withId(() => [
            _createVNode(_component_el_radio, {
              class: "radio",
              modelValue: _ctx.timeFormat,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.timeFormat = $event)),
              label: 2
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString("24"+_ctx.$wordList.NavInHtmlHourFormat), 1)
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_el_radio, {
              class: "radio",
              modelValue: _ctx.timeFormat,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.timeFormat = $event)),
              label: 1
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString("12"+_ctx.$wordList.NavInHtmlHourFormat), 1)
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          label: _ctx.$wordList.NavInHtmlDateFormat
        }, {
          default: _withId(() => [
            _createVNode(_component_cus_select, {
              modelValue: _ctx.dateFormat,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.dateFormat = $event)),
              placeholder: ""
            }, {
              default: _withId(() => [
                _createVNode(_component_cus_option, {
                  label: _ctx.$wordList.NavInHtmlYear+'-'+_ctx.$wordList.NavInHtmlMonth+'-'+_ctx.$wordList.NavInHtmlDay,
                  value: 1
                }, null, 8, ["label"]),
                _createVNode(_component_cus_option, {
                  label: _ctx.$wordList.NavInHtmlMonth+'-'+_ctx.$wordList.NavInHtmlDay+'-'+_ctx.$wordList.NavInHtmlYear,
                  value: 3
                }, null, 8, ["label"]),
                _createVNode(_component_cus_option, {
                  label: _ctx.$wordList.NavInHtmlDay+'-'+_ctx.$wordList.NavInHtmlMonth+'-'+_ctx.$wordList.NavInHtmlYear,
                  value: 5
                }, null, 8, ["label"])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _: 1
    }, 8, ["model", "label-position"]),
    _createVNode(_component_cus_button, {
      type: "blue",
      onClick: _ctx.submit
    }, {
      default: _withId(() => [
        _createTextVNode(_toDisplayString(_ctx.$wordList.TabelFootSubmit), 1)
      ]),
      _: 1
    }, 8, ["onClick"])
  ]))
})